<style lang="less" scoped>
  .title-area {
    border-radius: 50%;
    background-color: #fff800;
    color: #18a4ff;
    width: 247px;
    height: 247px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .text {
    text-align: center;
  }
  .small, .big {
    width: 100%;
  }
  .small {
    font-size: 32px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #18a4ff;
  }
  .big {
    font-size: 64px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #18a4ff;
  }
</style>

<template lang="pug">
  .title-area
    .text
      div.small 타임어택
      div.big {{text}}
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '텍스트',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/time_attack_title.vue